import React from 'react'
import { motion } from 'framer-motion'
import { twMerge } from 'tailwind-merge'

interface Props {
	step: number
}

export default function Stepper({ step }: Props) {
	return (
		<div className="relative my-6 flex items-center">
			<div className="absolute top-2 left-0 h-0.5 w-1/3 bg-gray-300"></div>
			{step > 0 && (
				<motion.div
					initial={{ scaleX: 0, originX: 0 }}
					animate={{ scaleX: 1, transition: { duration: 0.8 } }}
					exit={{ scaleX: 0, transition: { duration: 0.4 } }}
					className="absolute top-2 left-0 h-0.5 w-1/3 bg-ab-100"
				/>
			)}
			<div className="absolute top-2 right-0 left-0 mx-auto h-0.5 w-1/3  bg-gray-300"></div>
			{step > 1 && (
				<motion.div
					initial={{ scaleX: 0, originX: 0 }}
					animate={{ scaleX: 1, transition: { duration: 0.8 } }}
					exit={{ scaleX: 0, transition: { duration: 0.4 } }}
					className="absolute top-2 right-0 left-0 mx-auto h-0.5 w-1/3 bg-ab-100"
				/>
			)}
			<div className="absolute top-2 right-0 h-0.5 w-1/3  bg-gray-300"></div>
			{step > 2 && (
				<motion.div
					initial={{ scaleX: 0, originX: 0 }}
					animate={{ scaleX: 1, transition: { duration: 0.8 } }}
					exit={{ scaleX: 0, transition: { duration: 0.4 } }}
					className="absolute top-2 right-0 h-0.5 w-1/3 bg-ab-100"
				/>
			)}
			{/* Steps */}
			<div className="flex w-full justify-between">
				{/* Step 1 */}
				<div className="relative flex -translate-x-2 flex-col items-center text-center md:-translate-x-6">
					<div className="relative h-4 w-4 rounded-full bg-ab-100"></div>
					<p className="mt-2 hidden md:block">Contact</p>
					<p className="mt-2 block md:hidden">1</p>
				</div>

				{/* Step 2 */}
				<div className="relative flex flex-col items-center text-center">
					<div className={twMerge('relative h-4 w-4 rounded-full transition-colors duration-700', step > 0 ? 'bg-ab-100' : 'bg-gray-300')}></div>
					<p className="mt-2 hidden md:block">Details</p>
					<p className="mt-2 block md:hidden">2</p>
				</div>

				{/* Step 3 */}
				<div className="relative flex translate-x-2 flex-col items-center text-center md:translate-x-8">
					<div className={twMerge('relative h-4 w-4 rounded-full transition-colors duration-700', step > 1 ? 'bg-ab-100' : 'bg-gray-300')}></div>
					<p className="mt-2 hidden md:block">Products</p>
					<p className="mt-2 block md:hidden">3</p>
				</div>
				{/* Step 3 */}
				<div className="relative flex translate-x-2 flex-col items-center text-center md:translate-x-8">
					<div className={twMerge('relative h-4 w-4 rounded-full transition-colors duration-700', step > 2 ? 'bg-ab-100' : 'bg-gray-300')}></div>
					<p className="mt-2 hidden md:block">Comments</p>
					<p className="mt-2 block md:hidden">4</p>
				</div>
			</div>
		</div>
	)
}
